var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTak3Lengeh5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 30",
    style: {
      enableBackground: "new 0 0 60 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.2,15.2h-6.7c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h6.7c0.3,0,0.5,0.2,0.5,0.5C33.7,15,33.4,15.2,33.2,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,18.6c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v6.7C30.3,18.3,30.1,18.6,29.8,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30H0V0h60V30z M1,29h58V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,15.2h-6.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.1c0.3,0,0.5,0.2,0.5,0.5S53.4,15.2,53.1,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.4,17.4 47.4,12 44.7,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9,25.5H42.7V4.6h13.2V25.5z M43.6,24.6h11.3v-19H43.6V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,15.2H6.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.1c0.3,0,0.5,0.2,0.5,0.5S12.7,15.2,12.5,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.1,12 12.1,17.4 14.9,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9,25.5H3.6V4.6h13.2V25.5z M4.6,24.6h11.3v-19H4.6V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,29.9c-0.2,0-0.4-0.2-0.4-0.4V0.8c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v28.7C20.2,29.7,20,29.9,19.8,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9,29.9c-0.2,0-0.4-0.2-0.4-0.4V0.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v28.7C40.3,29.7,40.2,29.9,39.9,29.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTak3Lengeh5);
export default __webpack_public_path__ + "static/media/tak_3_lengeh_5.e5630699daeeac99083263aac7a1777f.svg";
export { ForwardRef as ReactComponent };